import { makeAutoObservable } from "mobx";
import { CronState } from "..";
export class StateProvider {
    constructor() {
        makeAutoObservable(this);
    }
    static getState() {
        if (typeof this.state === "undefined") {
            this.state = new CronState();
        }
        return this.state;
    }
}
StateProvider.state = undefined;
//# sourceMappingURL=StateProvider.js.map